export default "__VITE_ASSET__58fda589__"